// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__2j_DZ","error":"InputSecondary_error__WXh2e","disabled":"InputSecondary_disabled__3qGLb"};